import { Component, OnInit } from '@angular/core'
import { NavigationEnd, NavigationStart, Router } from '@angular/router'
import { combineLatest } from 'rxjs'
import { distinctUntilChanged, filter, map, tap } from 'rxjs/operators'
import { AppConfigService, JmlNavAdapterService } from '@dot-it/jml-lib'
import { PrimeNGConfig } from 'primeng/api'
import { RxStompService } from '../../projects/jml-lib/src/lib/app-config/rx-stomp.service'

@Component({
  selector: 'jml-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  constructor(
    private jmlNavAdapter: JmlNavAdapterService,
    private config: PrimeNGConfig,
    public appConfig: AppConfigService,
    public router: Router,
    public rxStomp: RxStompService
  ) {
    rxStomp.init()
  }

  ngOnInit(): void {
    // saving navigation events (those will be used to identify site state with browser navigation)
    combineLatest([
      this.router.events.pipe(
        filter((e) => e instanceof NavigationStart),
        map((e) => e as NavigationStart)
      ),
      this.router.events.pipe(
        filter((e) => e instanceof NavigationEnd),
        map((e) => e as NavigationEnd)
      )
    ])
      .pipe(
        distinctUntilChanged(
          (prev, next) => (!prev[0] && !next[0]) || (!!prev[0] && !!next[0] && prev[0].id === next[0].id)
        ), // comparing the first item should suffice.
        // tap(([navStart, navEnd]) => console.log('nav start and end', navStart, navEnd)),
        tap(([navStart, navEnd]) => this.jmlNavAdapter.setLastNavigation(navStart, navEnd))
      )
      .subscribe()

    this.appConfig.getUIInfo$().subscribe((uiInfo) => {
      if (!!uiInfo.customPrimaryColor && uiInfo.customPrimaryColor !== '#primary_color#') {
        const primary = Number(uiInfo.customPrimaryColor.replace('#', '0x'))
        document.documentElement.style.setProperty('--primary-color', uiInfo.customPrimaryColor)
        document.documentElement.style.setProperty(
          '--primary-color-rgb',
          `${(primary >> 16) & 0xff}, ${(primary >> 8) & 0xff}, ${primary & 0xff}`
        )
      }

      if (!!uiInfo.customGreeterGradient && uiInfo.customGreeterGradient !== '#greeter_gradient#') {
        document.documentElement.style.setProperty(
          '--greeter-gradient-1',
          `${uiInfo.customGreeterGradient.split('-')[0]}`
        )
        document.documentElement.style.setProperty(
          '--greeter-gradient-2',
          `${uiInfo.customGreeterGradient.split('-')[1]}`
        )
      }
    })

    this.config.setTranslation({
      firstDayOfWeek: 1,
      dayNames: ['Sonntag', 'Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag'],
      dayNamesShort: ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'],
      dayNamesMin: ['S', 'M', 'D', 'M', 'D', 'F', 'S'],
      monthNames: [
        'Januar',
        'Februar',
        'März',
        'April',
        'Mai',
        'Juni',
        'Juli',
        'August',
        'September',
        'Okotober',
        'November',
        'Dezember'
      ],
      monthNamesShort: ['Jan', 'Feb', 'Mrz', 'Apr', 'Mai', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dez'],
      dateFormat: 'dd.mm.yy',
      today: 'Heute',
      clear: 'Verwerfen'
    })
  }
}
